import { Button, Popover, Tag } from "antd";
import Layout from "../../layout/Layout";
import { PlusOutlined } from "@ant-design/icons";
import { useCallback, useEffect, useState } from "react";
import AddFeaturedTeachersModal from "./components/add-featured-modal";
import actionBtn from "../../assets/images/actionbtn.png";

import AdminGrid from "../../components/adminGrid/adminGrid";
import { ImCancelCircle } from "react-icons/im";
import RemoveFeaturedTeachersModal from "./components/remove-featured-modal";
import TableSkeleton from "../../components/skeleton/table";
import api from "../../services/api";

const FeaturedTeachers = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [unfeaturedModal, setUnfeaturedModal] = useState(false);
  const [unFeatureTeacher, setUnFeatureTeacher] = useState({});

  const [isLoading, setIsLoading] = useState(false);
  const [featuredTeachers, setFeaturedTeachers] = useState([]);

  useEffect(() => {
    fetchFeaturedTeachers();
  }, []);

  const fetchFeaturedTeachers = async () => {
    try {
      setIsLoading(true);
      const req = await api.get(
        "/teachers?isFeatured=true"
      );
      // console.log("req", req?.data);
      setFeaturedTeachers(req?.data?.data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const refreshData = useCallback(async () => {
    await fetchFeaturedTeachers();
  }, []);

  const centerStyle = {
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
  };

  const getRowHeight = (params) => {
    var Heights = [55, 55, 55, 55];
    return Heights[params.node.rowIndex % 4];
  };

  const gridOptions = {
    getRowHeight: getRowHeight,
  };

  const actionCellRendererPending = ({ data }) => (
    <Popover
      content={
        <div>
          <Button
            className="btn btn-sm text-danger fs_12 border-0"
            onClick={() => {
              setUnfeaturedModal(true);
              setUnFeatureTeacher(data);
            }}
          >
            <div className="d-flex justify-content-between">
              <div className="mr-2">
                <ImCancelCircle size={18} className={`text-secondary `} />
              </div>
              <div className="text-secondary">{"Mark un-featured"}</div>
            </div>
          </Button>
        </div>
      }
      trigger="click"
    >
      <img
        src={actionBtn}
        alt="Warning / Blocked"
        style={{ width: "30px", height: "17px", cursor: "pointer" }}
      />
    </Popover>
  );

  const columns = [
    {
      headerName: "Teacher",
      field: "fullName",
      flex: 1,
      filter: true,
    },
    {
      headerName: "Subject",
      field: "courses",
      flex: 1,
      filter: true,
      cellStyle: centerStyle,
      cellRenderer: (params) => {
        const courses = params.data?.courses || [];
        // Extract the courseSubjectName from each course object and join them with commas
        return courses.length > 0
          ? courses.map((course) => course?.courseSubjectName).join(", ")
          : "N/A";
      },
    },
    {
      headerName: "Featured",
      field: "isFeatured",
      flex: 1,
      filter: true,
      cellStyle: centerStyle,
      cellRenderer: (params) => {
        return (
          <Tag color="cyan" size="small">
            Featured
          </Tag>
        );
      },
    },
    {
      headerName: "Action",
      field: "action",
      flex: 1,
      cellRenderer: actionCellRendererPending,
      cellStyle: centerStyle,
    },
  ];

  return (
    <Layout>
      <div className="container mt-4 overflow-hidden">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h3 className="h4">Featured Teachers</h3>
          <Button
            type="primary"
            size="middle"
            className="btn btn_contained fs_12 btn-sm text-white px-3"
            icon={<PlusOutlined />}
            onClick={() => setIsOpen(true)}
          >
            Add
          </Button>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12 col-lg-12 col-12">
          {isLoading ? (
            <TableSkeleton columns={4} rows={6} />
          ) : (
            <AdminGrid
              row={featuredTeachers}
              cols={columns}
              rowClass={"fs_12"}
              gridOptions={gridOptions}
              style={{ height: "100%" }}
              pagination={true}
            />
          )}
        </div>
      </div>

      {isOpen ? (
        <AddFeaturedTeachersModal
          show={isOpen}
          onCancel={() => setIsOpen(false)}
          refreshData={refreshData}
        />
      ) : null}

      {unfeaturedModal && unFeatureTeacher ? (
        <RemoveFeaturedTeachersModal
          show={unfeaturedModal}
          onCancel={() => setUnfeaturedModal(false)}
          selectedTeacher={unFeatureTeacher}
          refreshData={refreshData}
        />
      ) : null}
    </Layout>
  );
};

export default FeaturedTeachers;
